import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CashReconciliationDto,
  CashReconciliationListDto,
  CashReconciliationFilterDto,
  CreateCashReconciliationRequest,
  RecordCashAmountsRequest,
  RecordActualCountRequest,
  ApproveVarianceRequest,
  RejectVarianceRequest,
  RejectCashReconciliationRequest,
} from '@/types/cashReconciliation.types';

export const cashReconciliationApi = {
  /** GET /api/v1/cash-reconciliations — paginated list with optional filter */
  getList: (filter?: CashReconciliationFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CashReconciliationListDto>>>('/cash-reconciliations', {
      params: filter,
    }),

  /** GET /api/v1/cash-reconciliations/{id} — full reconciliation record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}`),

  /** POST /api/v1/cash-reconciliations — create a new reconciliation */
  create: (data: CreateCashReconciliationRequest) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>('/cash-reconciliations', data),

  /** PUT /api/v1/cash-reconciliations/{id}/cash-amounts — record cash flow amounts */
  recordCashAmounts: (id: string, data: RecordCashAmountsRequest) =>
    apiClient.put<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/cash-amounts`, data),

  /** PUT /api/v1/cash-reconciliations/{id}/actual-count — record denomination counts */
  recordActualCount: (id: string, data: RecordActualCountRequest) =>
    apiClient.put<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/actual-count`, data),

  /** POST /api/v1/cash-reconciliations/{id}/submit */
  submit: (id: string) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/submit`),

  /** POST /api/v1/cash-reconciliations/{id}/approve */
  approve: (id: string) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/approve`),

  /** POST /api/v1/cash-reconciliations/{id}/reject */
  reject: (id: string, data: RejectCashReconciliationRequest) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/reject`, data),

  /** POST /api/v1/cash-reconciliations/{id}/approve-variance */
  approveVariance: (id: string, data: ApproveVarianceRequest) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/approve-variance`, data),

  /** POST /api/v1/cash-reconciliations/{id}/reject-variance */
  rejectVariance: (id: string, data: RejectVarianceRequest) =>
    apiClient.post<ApiResponse<CashReconciliationDto>>(`/cash-reconciliations/${id}/reject-variance`, data),

  /** DELETE /api/v1/cash-reconciliations/{id} — soft-delete */
  deleteRecon: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/cash-reconciliations/${id}`),
};
